import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { IServerResponse, ServerResponse } from '../../models/server-response.model';
import { UtilService } from '../util/util.service';
import { NeighborhoodService } from '../neighborhood/neighborhood.service';
import { StreetBuildingService } from '../street-bulding/street-building.service';
import { INotificationApp, NotificationApp } from '../../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  public notifications: NotificationApp[] = [];

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private neighborhoodService: NeighborhoodService,
    private streetBuildingService: StreetBuildingService,
    private utilService: UtilService
  ) { }

  get unseenCount(): number {
    return this.notifications.filter(n => !n.seen).length;
  }

  /* -------------------------------------------------------------------------- */
  /*                          ANCHOR canTapNotification                         */
  /* -------------------------------------------------------------------------- */
  // region canTapNotification
  canTapNotification(notification: NotificationApp): boolean {
    return notification.canTap && (
      notification.notificationType?.code !== 'chat' ||
      (
        !!notification.fromHouseFlatId &&
        !!this.neighborhoodService.currentNeighborhood?.chatModule &&
        // Casa desconocida (lista sin cargar) se permite; el guard de la ruta es el respaldo
        this.streetBuildingService.findHouseFlat(notification.fromHouseFlatId)?.chatModule !== false
      )
    );
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR getAll                                */
  /* -------------------------------------------------------------------------- */
  // region getAll
  async getAll(): Promise<void> {

    const urlApi = `${environment.urlApi}/neighborhoods/${environment.neighborhoodId}/notifications`;

    try {

      const token = await this.authService.getToken();
      const headers = this.utilService.headers(token);

      const response = await new Promise<ServerResponse<{ notifications: INotificationApp[] }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ notifications: INotificationApp[] }>>(
            urlApi,
            { headers }
          ).subscribe({
            next: (response) => resolve(new ServerResponse(response)),
            error: (error) => {
              if (error.error) resolve(new ServerResponse(error.error));
              else reject(error);
            }
          });
        }
      );

      if (response.statusCode === 200) {
        this.notifications = (response.data?.notifications ?? []).map(
          n => new NotificationApp(n)
        );
      } else {
        console.log('Error al obtener notificaciones:', response.message);
      }

    } catch (error) {
      console.log(error);
    }

  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR markSeen                               */
  /* -------------------------------------------------------------------------- */
  // region markSeen
  async markSeen(notificationId: string): Promise<boolean> {

    const urlApi = `${environment.urlApi}/neighborhoods/${environment.neighborhoodId}/notifications/${notificationId}`;

    try {

      const token = await this.authService.getToken();
      const headers = this.utilService.headers(token);

      const response = await new Promise<ServerResponse<{ notification: INotificationApp }>>(
        (resolve, reject) => {
          this.http.put<IServerResponse<{ notification: INotificationApp }>>(
            urlApi,
            { seen: true },
            { headers }
          ).subscribe({
            next: (response) => resolve(new ServerResponse(response)),
            error: (error) => {
              if (error.error) resolve(new ServerResponse(error.error));
              else reject(error);
            }
          });
        }
      );

      if (response.statusCode === 200) {
        const index = this.notifications.findIndex(n => n.notificationId === notificationId);
        if (index >= 0) {
          this.notifications[index].seen = true;
          this.notifications = [...this.notifications];
        }
        return true;
      }

    } catch (error) {
      console.log(error);
    }

    return false;

  }

}
